import { render, staticRenderFns } from "./atcCommodity.vue?vue&type=template&id=0693555a&"
import script from "./atcCommodity.vue?vue&type=script&lang=ts&"
export * from "./atcCommodity.vue?vue&type=script&lang=ts&"
import style0 from "./atcCommodity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports